import {act, render} from '@testing-library/react/pure';
import {QueryClient, QueryClientProvider} from 'react-query';
import DiscountMessage from '.';

describe('DiscountMessage', () => {
  const mockColor = {legacyColorId: 1};
  const mockDiscountPercentage = 10;
  const mockCanOrderSingles = true;
  const mockMinQty = 5;

  test('renders the correct discount message', async () => {
    const queryClient = new QueryClient();

    let findAllByText;
    await act(async () => {
      ({findAllByText} = render(
        <QueryClientProvider client={queryClient}>
          <DiscountMessage
            currentColor={mockColor}
            discountPercentage={mockDiscountPercentage}
            canOrderSingles={mockCanOrderSingles}
            minQty={mockMinQty}
          />
        </QueryClientProvider>
      ));
    });

    const elements = await findAllByText(/Buy more, save more/i, {
      exact: false
    });
    elements.forEach((el) => {
      expect(el.textContent).toEqual('Buy more, save more!');
    });
  });
});
